<template>
  <div>
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>查看物流</span>
      </div>
      <div>
        <el-steps direction="vertical" :active="0" v-if="message==='ok'">
          <el-step v-for="(item,index) in list" v-bind:key="index" :title="item.context" :description="item.ftime"></el-step>
        </el-steps>
      </div>
    </el-card>
  </div>
</template>
<script>

import {
  Usercenter
} from "../../model/usercenter.js";
let usercenter = new Usercenter();
export default {
  name: 'wuliu',
  data() {
    return {
      orderId: this.$route.query.OrderId,
      nu: '',
      state: '',
      message: 'ok',
      type: '',
      photo: '',
      list: []
    }
  },
  components: {

  },
  computed: {
    stateText: {
      get() {
        switch (this.state) {
          case '0':
            return '运输中'

          case '1':
            return '已揽收'

          case '2':
            return '疑难件'

          case '3':
            return '已签收'

          case '4':
            return '退签'

          case '5':
            return '正在派件'

          case '6':
            return '已退回'

          default:
            return ''
        }
      },
      set() {
      }
    }
  },
  methods: {
    logistics() {
      let _this = this;
      usercenter.logistics({
        OrderId: _this.orderId,
      }).then(function (res) {
        let log = res.data;
        _this.photo = res.photo;
        _this.type = res.type;
        if (log) {
          if (log.message === 'ok') {
            _this.message = 'ok';
            _this.list = log.data;
            _this.nu = log.nu;
            _this.state = log.state;
          } else if (log.result == false) {
            _this.message = log.message;
          } else {
            _this.message = "唉哟，系统繁忙请稍候再试，" + log.message
          }
        }
      }).catch(() => {

      })
    }
  },
  created() {
    let _this = this;
    if (!_this.orderId) {
      _this.$router.push({ path: '/usercenter/orderlist' })
    }
  },
  mounted() {
    this.logistics()
  },
  watch: {

  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/card.scss";
</style>